/**
 * ImageWrapper component that gates between @compiled/react and @atlaskit/css implementations
 */
import React from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { StyledImageWrapper } from './ImageWrapperStyled.tsx';
import { ImageWrapperCss } from './ImageWrapperCss.tsx';

export type ImageWrapperProps = {
	coverPicturePosition?: number | null;
	isFixedWidthImageOption?: boolean;
} & React.ComponentProps<'img'>;

export const ImageWrapper = ({
	coverPicturePosition,
	isFixedWidthImageOption,
	...imgProps
}: ImageWrapperProps) => {
	if (expValEquals('confluence_page_cover_picture_css_migration', 'isEnabled', true)) {
		return (
			<ImageWrapperCss
				{...imgProps}
				coverPicturePosition={coverPicturePosition}
				isFixedWidthImageOption={isFixedWidthImageOption}
			/>
		);
	}

	return (
		<StyledImageWrapper
			{...imgProps}
			// need this empty alt tag for decorative images
			alt=""
			coverPicturePosition={coverPicturePosition}
			isFixedWidthImageOption={isFixedWidthImageOption}
		/>
	);
};
